// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDictionary as getDictionaryAPI,
    addDictionary as addDictionaryAPI,
    // updateDictionary as updateDictionaryAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { languagesApiResponseError, languagesApiResponseSuccess } from './actions';
import { LanguagesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getDictionary({ payload: dictionary }) {
    try {
        const response = yield call(getDictionaryAPI, { ...dictionary });
        const dictionaryItem = response.data.data;
        yield put(languagesApiResponseSuccess(LanguagesActionTypes.GET_DICTIONARY, dictionaryItem));
    } catch (error) {
        yield put(languagesApiResponseError(LanguagesActionTypes.GET_DICTIONARY, error));
    }
}

function* addDictionary({ payload: dictionary }) {
    try {
        const dataToSend = { ...dictionary }
        const response = yield call(addDictionaryAPI, dataToSend)
        const dictionaryItem = response.data
        yield put(languagesApiResponseSuccess(LanguagesActionTypes.ADD_DICTIONARY, dictionaryItem))
    } catch (error) {
        yield put(languagesApiResponseError(LanguagesActionTypes.ADD_DICTIONARY, error))
    }
}

// function* updateDictionary({ payload: dictionary }) {
//     try {
//         const response = yield call(updateDictionaryAPI, { ...dictionary })
//         const dictionaryItem = response.data.data
//         yield put(languagesApiResponseSuccess(LanguagesActionTypes.UPDATE_DICTIONARY, dictionaryItem))
//     } catch (error) {
//         yield put(languagesApiResponseError(LanguagesActionTypes.UPDATE_DICTIONARY, error))
//     }
// }

export function* watchGetDictionary(): any {
    yield takeEvery(LanguagesActionTypes.GET_DICTIONARY, getDictionary);
}

export function* watchAddDictionary(): any {
    yield takeEvery(LanguagesActionTypes.ADD_DICTIONARY, addDictionary)
}
// export function* watchUpdateDictionary(): any {
//     yield takeEvery(LanguagesActionTypes.UPDATE_DICTIONARY, updateDictionary)
// }

function* languagesSaga(): any {
    yield all([
        fork(watchGetDictionary),
        fork(watchAddDictionary),
        // fork(watchUpdateDictionary),
    ]);
}

export default languagesSaga;
